'use es6';

import { Record } from 'immutable';
import { Networks } from '../../lib/Constants';
import AdWordsBiddingStrategyConfigurationEntityRecord from '../rmf/AdWordsBiddingStrategyConfigurationEntityRecord'; // TODO: Can be removed once ungated to Google Ads API
//https://git.hubteam.com/HubSpot/Ads/blob/master/AdsData/src/main/java/com/hubspot/ads/data/adwords/AbstractAdGroupView.java

export default Record({
  id: null,
  campaignId: null,
  accountId: null,
  network: Networks.ADWORDS,
  name: null,
  status: null,
  trackingUrlTemplate: null,
  //maxCpc: null,
  targetCpa: null,
  targetRoas: null,
  biddingStrategyConfiguration: new AdWordsBiddingStrategyConfigurationEntityRecord(),
  previousState: null,
  averagePosition: null,
  conversionRate: null,
  maxCpc: null
});